import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=39ba8d84&scoped=true&"
var script = {}
import style0 from "./Intro.vue?vue&type=style&index=0&id=39ba8d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba8d84",
  null
  
)

export default component.exports